export function initAjaxFilterShop($) {
    const $shopContent = $('#shop-content');
    const $shopControls = $('#shop-controls');
    if (!$shopContent.length) return;

    // cache DOM elements
    const $filters = $('[data-filter-input]');
    const $sortSelect = $('select.orderby[name="orderby"]');
    const $searchInput = $('#search-products');

    // utils
    const debounce = (fn, wait) => {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...args), wait);
        };
    };

    const collectCategories = () => {
        return $('.category-filter:checked')
            .map((_, el) => el.value)
            .get();
    };

    const getPresetCategory = () => {
        const $preselectedCategory = $('#product-cat');
        if ($preselectedCategory) return [$preselectedCategory.val()];
        return null;
    }

    const getPresetAttribute = () => {
        const $preselectedAttribute = $('#product-attr');
        if ($preselectedAttribute) {
            return {
                name: $preselectedAttribute.attr('name'),
                value: $preselectedAttribute.val()
            };
        }
        return null;
    }

    function renderBreadcrumb(nav, items) {
        if (!nav) return;

        nav.replaceChildren();

        items.forEach((item, index) => {
            const isLast = index === items.length - 1;

            if (!isLast && item.url) {
                const a = document.createElement('a');
                a.href = item.url;
                a.textContent = item.label;
                nav.appendChild(a);
            } else {
                nav.appendChild(document.createTextNode(item.label));
            }

            if (!isLast) {
                nav.appendChild(document.createTextNode(' / '));
            }
        });
    }

    const collectAttributes = () => {
        const out = {};

        $('[data-filter-input][data-attribute]').each(function () {
            const key = $(this).data('attribute');
            if (!out[key]) out[key] = [];
            if (this.checked) out[key].push(this.value);
        });

        return out;
    };

    const getPageFromURL = () => {
        const match = location.pathname.match(/\/page\/(\d+)/);
        return match ? Number(match[1]) : 1;
    };

    const updateURL = (data) => {
        const params = new URLSearchParams();

        if (data.categories.length) params.set('categories', data.categories.join(','));
        if (data.min_price) params.set('min_price', data.min_price);
        if (data.max_price) params.set('max_price', data.max_price);
        if (data.in_stock) params.set('in_stock', '1');
        if (data.on_sale) params.set('on_sale', '1');
        if (data.orderby && data.orderby !== 'menu_order') params.set('orderby', data.orderby);
        if (data.s) params.set('s', data.s);

        let path = location.pathname.replace(/\/page\/\d+\/?$/, '');

        if (data.page > 1) {
            path = `${path.replace(/\/$/, '')}/page/${data.page}/`;
        }

        history.pushState({}, '', `${path}?${params}`);

        Object.entries(data.attributes).forEach(([key, value]) => {
            let slug = key.replace('pa_', '');
            if (value.length && slug.length) {
                params.set(`filter_${slug}`, value.join(','));
                params.set(`query_type_${slug}`, 'or');
            }
        });

        history.pushState({}, '', `${location.pathname}?${params}`);
    };

    const filterProducts = (page = 1) => {
        const data = {
            action: 'jn_filter_shop', // or whatever value is defined in the WordPress hook
            nonce: ajaxShopParams.nonce,
            page,
            categories: collectCategories(),
            preset_category: getPresetCategory(),
            preset_attribute: getPresetAttribute(),
            min_price: $('#min-price').val(),
            max_price: $('#max-price').val(),
            in_stock: $('#in-stock').is(':checked'),
            on_sale: $('#on-sale').is(':checked'),
            attributes: collectAttributes(),
            orderby: $sortSelect.val(),
            s: $searchInput.val(),
            with_controls: $shopControls.children().length < 2 ? 1 : 0,
        };

        updateURL(data);
        $shopContent.addClass('loading');

        $.post(ajaxShopParams.ajax_url, data)
            .done(res => {
                if (res.success) {
                    $shopContent.html(res.data.shop_content);

                    if (res.data.shop_controls) {
                        $shopControls.html(res.data.shop_controls);
                    } else {
                        $('.woocommerce-result-count').text(`Showing ${res.data.count} results`);
                    }

                    if (res.data.breadcrumbs) {
                        let crumbs = res.data.breadcrumbs;
                        $('.woocommerce-products-header__title').text(crumbs[crumbs.length - 1].label);
                        renderBreadcrumb(document.querySelector('.woocommerce-breadcrumb'), crumbs);
                    }
                }
            })
            .always(() => {
                $shopContent.removeClass('loading');
            });
    };

    const loadFromURL = () => {
        const params = new URLSearchParams(location.search);

        const page = getPageFromURL();

        $('[data-filter-input][data-attribute]').prop('checked', false);

        // collect categories
        if (params.has('categories')) {
            const cats = params.get('categories').split(',');
            $('.category-filter').each(function () {
                this.checked = cats.includes(this.value);
            });
        }

        // collect filter_* params i.e. attributes
        for (const [key, value] of params.entries()) {
            if (!key.startsWith('filter_')) continue;

            // replace woocommerce param from filter_ to pa_
            const attributeKey = key.replace('filter_', 'pa_');
            const values = value.split(',');

            values.forEach(val => {
                $(`[data-filter-input][data-attribute="${attributeKey}"][value="${val}"]`)
                    .prop('checked', true)
                    .trigger('change');
            });
        }

        if (params.has('min_price')) $('#min-price').val(params.get('min_price'));
        if (params.has('max_price')) $('#max-price').val(params.get('max_price'));
        if (params.has('in_stock')) $('#in-stock').prop('checked', true);
        if (params.has('on_sale')) $('#on-sale').prop('checked', true);
        if (params.has('orderby')) $sortSelect.val(params.get('orderby'));
        if (params.has('s')) $searchInput.val(params.get('s'));

        // const page = params.has('paged') ? Number(params.get('paged')) : 1;
        // filterProducts(page);
    };

    // bindings
    loadFromURL();

    // filter products when filter controls change
    $filters.on('change', debounce(() => filterProducts(1), 300));
    $('#min-price, #max-price').on('input', debounce(() => filterProducts(1), 500));
    $('form.woocommerce-ordering').on('submit', (e) => {
        e.preventDefault();
        filterProducts(1);
    });
    $searchInput.on('input', debounce(() => {
       filterProducts(1);

       if (window.posthog) {
           posthog.capture('search_performed', {
               query: $searchInput.val(),
           })
       }

    }, 500))
    // handle pagination
    $shopContent.on('click', '.woocommerce-pagination a', e => {
        e.preventDefault();
        const href = e.currentTarget.href;
        let page = 1;
        const pathMatch = href.match(/\/page\/(\d+)/);
        if (pathMatch) {
            page = Number(pathMatch[1]);
        } else {
            const qsMatch = href.match(/[?&]paged=(\d+)/);
            if (qsMatch) page = Number(qsMatch[1]);
        }
        filterProducts(page);
        $('html').scrollTop(0);
    });

    // handle browser back/forward buttons
    window.addEventListener('popstate', loadFromURL);

    // add layout controls
    $(document).on('change', '.product-layout', function () {
        const $products = $('#shop-content');
        $products.toggleClass('--is-list', this.value === 'list');
    });
}
